export default __webpack_public_path__ + "static/media/help.24dd66d1.png";